module.exports = __webpack_public_path__ + "static/media/4S.60f43735.svg";